module.exports = __webpack_public_path__ + "static/media/btn_app_store.d77a879e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/EBook/imgs/btn_app_store.png
// module id = 1638
// module chunks = 0